export default __webpack_public_path__ + "images/stripe-payment-element/apple-pay-82f8fa88a152776223f466463b03773d.svg";